import { motion } from "framer-motion";
import { MANIFESTO } from "../data/content";

const Manifesto = () => (
  <section
    id="why"
    data-testid="manifesto-section"
    className="relative bg-[#0a0a0a] text-white py-24 md:py-36 overflow-hidden"
  >
    <div className="paper-noise absolute inset-0 opacity-[0.04] pointer-events-none" />
    <div className="relative max-w-6xl mx-auto px-5 md:px-8">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-sm font-bold uppercase tracking-[0.2em] text-[#58cc02]"
      >
        Why this actually works
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="font-display font-extrabold text-4xl md:text-6xl tracking-tight mt-4 max-w-3xl"
      >
        Not another course. A writing habit that scores.
      </motion.h2>

      <div className="mt-16 divide-y divide-white/10">
        {MANIFESTO.map((m, i) => (
          <motion.div
            key={m.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="grid md:grid-cols-12 gap-4 md:gap-8 py-10 group"
            data-testid={`manifesto-item-${i + 1}`}
          >
            <div className="md:col-span-2">
              <span className="font-display font-black text-6xl md:text-7xl text-white/10 group-hover:text-[#58cc02] transition-colors duration-500">
                {m.n}
              </span>
            </div>
            <h3 className="md:col-span-5 font-display font-extrabold text-2xl md:text-4xl tracking-tight leading-tight">
              {m.title}
            </h3>
            <p className="md:col-span-5 text-lg text-white/70 leading-relaxed self-center">
              {m.body}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
